export default __webpack_public_path__ + "static/media/logoRoboclickName.c88a9af8.svg";